import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@/assets/vikingbet/images/logo.svg';
import { THEME_NAME } from '@/constants/themeConfig';

export default function Index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image
          src={logo}
          alt={`${THEME_NAME.vikingbet}`}
          data-testid={`${THEME_NAME.vikingbet}_desktop`}
          mx="auto"
          mb="4"
          w="156px"
          h={{ base: '8', lg: 'auto' }}
          filter="drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))"
        />
      </Show>
      <Hide above="lg">
        <Image
          src={logo}
          maxW="80px"
          alt={`${THEME_NAME.vikingbet}`}
          data-testid={`${THEME_NAME.vikingbet}_mobile`}
        />
      </Hide>
    </Link>
  );
}
